import React, { Component } from "react";
import PrivacyPolicyView from "./PrivacyPolicyView";
class PrivacyPolicyContainer extends Component {
  render() {
    return <PrivacyPolicyView {...this.props} />;
  }
}


export default PrivacyPolicyContainer;